import { render, staticRenderFns } from "./FindDuplicatesDialog.vue?vue&type=template&id=4f2b30c2"
import script from "./FindDuplicatesDialog.vue?vue&type=script&lang=js"
export * from "./FindDuplicatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports